"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchVerifyOtp = void 0;
const fetchVerifyOtp = (api, progressId, body) => api.POST(`${window.MIDDLEWARE_AUTH_SERVICE_HOST}/authorize/otp/verify`, body, {
    headers: {
        progressId,
    },
});
exports.fetchVerifyOtp = fetchVerifyOtp;
//# sourceMappingURL=resolver.js.map